// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--V6Ruf","link":"_93444fe79c--link--bjxeF","title":"_93444fe79c--title--fJOs7","dot":"_93444fe79c--dot--dXNXB"};